import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);

        this.foreground = this.getData('foreground');
    }

    init() {

        if(this.foreground != '#ffffff') {
            html.classList.add(`has-theme-dark-top`);
            html.classList.add(`has-theme-dark-middle`);
            html.classList.add(`has-theme-dark-bottom`);
        }
    }
}
